import React, {Component} from 'react';
import Seller from './Seller';
import Buyer from './Buyer';
import PropTypes from 'prop-types';
import {getDateString, notify, reportEvent, updateNotify} from '../helper';

class GigBanner extends Component {

    constructor(props) {
        super(props);

        this.state = {
            notify: false,
            showNotify: false
        };

        this.notifyBuyer = this.notifyBuyer.bind(this);
        this.clickContact = this.clickContact.bind(this);
    }

    componentDidMount() {
        updateNotify(this.props.gigId)
            .then((data) => {
                this.setState({
                    notify: data.guest || data.is_buyer_waiting_for_gig,
                    showNotify: !data.guest
                });
            });
    }

    notifyBuyer() {
        notify(this.props.gigId)
            .then((data) => {
                if (data.status === 'success') {
                    reportEvent('notify_me.by_buyer_request', {
                        'gig': {
                            'id': this.props.gigId || Fiverr.models.ps.gig_id
                        }
                    });

                    this.setState({
                        notify: true
                    });
                } else {
                    throw '';
                }
            });
    }

    clickContact() {
        reportEvent('contact_me.click', {
            'current_page_type': 'gigs_page',
            'gig': {
                'id': this.props.gigId || Fiverr.models.ps.gig_id
            }
        }, 'conversation');
    }

    render() {
        const {
            notify,
            showNotify
        } = this.state;

        const {
            isOnVacation,
            dateVal,
            allowContact,
            isPageOwner,
            username,
            openPopup,
            turnOff,
            userId,
            profileImageUrl,
            isMobile
        } = this.props;

        if (!isOnVacation) {
            return null;
        }

        const hideBannerClass = !isOnVacation ? ' hidden' : '',
            endDate = dateVal ? getDateString(dateVal) : dateVal;

        return (
            <div className={`banner gig-page cf${hideBannerClass}`}>
                <div className="img-wrapper">
                    <span className="user-pict-60">
                        <img src={profileImageUrl} alt={username}/>
                    </span>
                    <span className="user-ooo-indicator"/>
                </div>
                {
                    isPageOwner ?
                        (<Seller endDate={endDate}
                            openPopup={openPopup}
                            turnOff={turnOff}
                            userId={userId}
                            isMobile={isMobile}/>)
                        : (<Buyer endDate={endDate}
                            allowContact={allowContact}
                            notify={notify}
                            showNotify={showNotify}
                            notifyBuyer={this.notifyBuyer}
                            username={username}
                            clickContact={this.clickContact}/>)
                }
            </div>
        );
    }
}

GigBanner.propTypes = {
    isPageOwner: PropTypes.bool,
    isOnVacation: PropTypes.bool,
    profileImageUrl: PropTypes.string,
    username:PropTypes.string,
    allowContact: PropTypes.bool
};

GigBanner.defaultProps = {
    isPageOwner: false,
    isOnVacation: false,
    profileImageUrl: '',
    username: '',
    allowContact: false
};

export default GigBanner;




// WEBPACK FOOTER //
// ./src/GigBanner/GigBanner.js